import React, { useEffect, useMemo, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-bootstrap';
import { BPagination } from '../../shared/Pagination';

export const ApplicationGrid = ({ onUpdate, ...props }) => {
    const [editingId, setEditingId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const [editingItem, setEditingItem] = useState(null);
    const [isValidUrl, setIsValidUrl] = useState(true);
    const items = useMemo(() => props.items, [props.items]);

    useEffect(() => {
        setCurrentPage(1);
        handleCancel();
        const result = paginateData({ data: items, currentPage, itemsPerPage });
        setPaginatedData(result);
    }, [items]);

    const handlePaginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        const result = paginateData({ data: items, currentPage: pageNumber, itemsPerPage });
        setPaginatedData(result);
    };

    const paginateData = ({ data, currentPage, itemsPerPage }) => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;

        return data.slice(indexOfFirstItem, indexOfLastItem);
    };

    const handleEdit = (id) => {
        setEditingId(id);
        setEditingItem(paginatedData.find(f => f.id === id));
    };

    const handleSave = (id, newData) => {
        if (!isValidUrl) return;

        if (id && newData?.id === id) {
            onUpdate(newData);
            handleCancel();
        } else {
            handleCancel();
        }
    };

    const handleCancel = () => {
        setEditingId(null);
        setEditingItem(null);
        setIsValidUrl(true);
    };

    const handleOnChangeInput = (partialUpdate) => {
        setEditingItem({ ...editingItem, ...partialUpdate });
    };

    const isValidURL = (urlString) => {
        try {
            new URL(urlString);
            console.log(new URL(urlString));
            return true;
        } catch (error) {
            return false;
        }
    };

    return (<>
        <Row>
            <Col>
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                        <tr>
                            <th scope="col">Display Name</th>
                            <th scope="col">Description</th>
                            <th scope="col">Support Group</th>
                            <th scope="col">Business Owner</th>
                            <th scope="col">System Owner</th>
                            <th scope="col">Url</th>
                            <th scope="col">API Path</th>
                            <th scope="col">Display</th>
                            <th scope="col" className="text-center">
                                <span className="text-center">Actions</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>

                        {(paginatedData).map((item, idx) => (<tr key={idx}>
                            <td scope="col">
                                {editingId === item.id && editingItem ? (<Form.Group>
                                    <Form.Control type="text" value={editingItem.label}
                                                  onChange={(e) => handleOnChangeInput({ label: e.target.value })} />
                                    <Form.Control.Feedback type="invalid" tooltip>
                                        Enter a valid Label
                                    </Form.Control.Feedback>
                                </Form.Group>) : (item.label)}
                            </td>
                            <td scope="col">
                                {editingId === item.id && editingItem ? (<Form.Group>
                                    <Form.Control type="text" value={editingItem.description}
                                                  onChange={(e) => handleOnChangeInput({ description: e.target.value })} />
                                    <Form.Control.Feedback type="invalid" tooltip>
                                        Enter a valid Description
                                    </Form.Control.Feedback>
                                </Form.Group>) : (item.description)}
                            </td>
                            <td scope="col">{item.supportGroup}</td>
                            <td scope="col">{item.businessOwner}</td>
                            <td scope="col">{item.systemOwner}
                            </td>
                            <td scope="col">
                                {editingId === item.id && editingItem ? (<Row><Form.Group className="w-100">
                                    <Form.Control className="w-100" type="text" isInvalid={!isValidUrl}
                                                  value={editingItem.url}
                                                  onBlur={(e) => {
                                                      console.log(e);
                                                      const valid = isValidURL(e.target.value);
                                                      setIsValidUrl(valid);
                                                  }}
                                                  onChange={(e) => handleOnChangeInput({ url: e.target.value })} />
                                    <Form.Control.Feedback type="invalid" tooltip
                                                           style={{ display: 'static' }}>
                                        Enter a valid URL
                                    </Form.Control.Feedback>
                                </Form.Group></Row>) : (<span className="text-wrap d-block " style={{ width: '300px' }}>
                                {item.url}
                            </span>)}

                            </td>
                            <td scope="col">
                                <span className="text-wrap d-block w-75">  {item.apiPath}</span>
                            </td>
                            <td scope="col">
                                {editingId === item.id && editingItem ? (
                                    <Form.Check className="text-center" checked={editingItem.display}
                                                disabled={editingId !== item.id}
                                                onChange={(e) => handleOnChangeInput({ display: e.target.checked })}></Form.Check>) : (
                                    <Form.Check className="text-center" checked={item.display} disabled></Form.Check>)}


                            </td>
                            <td scope="col">
                                <div className="text-center">
                                    {editingId === item.id ? (<>
                                        <button className="btn  btn-light" title="Save" disabled={!isValidUrl}
                                                onClick={() => handleSave(item.id, editingItem)}>
                                            <i className="fas fa-save text-black" />
                                        </button>
                                        <button className="btn  btn-light" title="Cancel"
                                                onClick={() => handleCancel()}>
                                            <i className="fas fa-times" />
                                        </button>
                                    </>) : !editingId ? (<button className="btn  btn-light" title="Edit"
                                                                 onClick={() => handleEdit(item.id)}>
                                        <i className="fas fa-edit text-black" />
                                    </button>) : null}
                                </div>
                            </td>
                        </tr>))}
                        </tbody>
                    </table>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div className="row">
                    <div className="col-md-4 offset-md-8">
                        <BPagination paginate={(pageNumber) => handlePaginate(pageNumber)}
                                     currentPage={currentPage}
                                     itemsPerPage={itemsPerPage}
                                     totalItems={props.items?.length || 0} />
                    </div>
                </div>
            </Col>
        </Row>
    </>);
};
